import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

import _ from 'underscore';

import {
  withTrack,
  APPLY_ACTION_TYPES,
  ADINSIGHT_LOG_ACTION_TYPE,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { handleRecommendationNotification } from '@bingads-webui-campaign/recommendation-notification';
import { NavigateModal } from '@bingads-webui-campaign-react/recommendation-navigate-modal';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

import { FeedbackForm } from './feedback-form';
import { DismissAllFeedbackForm } from './dismiss-all-feedback-form';
import { ApplyFeedbackForm } from './apply-feedback-form';
import { NAVIGATE_REASON } from './reason-const';
import { reasonToMtTranslator } from './utils';

class feedbackModal extends React.PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    recommendationDescription: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    isProvideFeedbackOnly: PropTypes.bool,
    isReject: PropTypes.bool,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    data: PropTypes.objectOf(PropTypes.any),
    track: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    logOpportunityEvent: PropTypes.func,
    callback: PropTypes.func.isRequired,
    context: PropTypes.objectOf(PropTypes.any),
    guid: PropTypes.string,
    isApplyFeedBackFormShow: PropTypes.bool,
    cid: PropTypes.string,
    aid: PropTypes.string,
    odata: PropTypes.PropTypes.shape({
      patch: PropTypes.func.isRequired,
    }),
    onAutoApplyCancel: PropTypes.func,
    isFromSummary: PropTypes.bool,
    isFromAutoApplyDialog: PropTypes.bool,
    view: PropTypes.objectOf(PropTypes.any),
    showAlertHandler: PropTypes.func,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    isDismissAll: PropTypes.bool,
    viewDetails: PropTypes.func,
    recommendationTypesAvailable: PropTypes.arrayOf(PropTypes.any),
    useCallbackAsSubmit: PropTypes.bool,
    permissions: PropTypes.objectOf(PropTypes.any),
    useNavigateModal: PropTypes.bool,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }),
    isFromImgExtV2: PropTypes.bool,
    opportunities: PropTypes.arrayOf(PropTypes.any),
  };

  static defaultProps = {
    context: null,
    isProvideFeedbackOnly: false,
    isReject: true,
    recommendationDescription: '',
    data: {},
    readOnly: false,
    logOpportunityEvent: null,
    guid: null,
    isApplyFeedBackFormShow: true,
    cid: null,
    aid: null,
    odata: null,
    onAutoApplyCancel: null,
    isFromSummary: false,
    isFromAutoApplyDialog: false,
    view: null,
    showAlertHandler: _.noop,
    overallOptimizationScoreBar: null,
    isDismissAll: false,
    viewDetails: _.noop,
    recommendationTypesAvailable: [],
    useCallbackAsSubmit: false,
    permissions: {},
    useNavigateModal: false,
    newI18n: {
      getString: _.noop,
    },
    isFromImgExtV2: false,
    opportunities: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      isNavigateModalOpen: false,
    };
    this.navigateToDetailType = RECOMMENDATION_TYPES.REALLOCATE_BUDGET;
  }

  onSubmit = (reason) => {
    const {
      data,
      isProvideFeedbackOnly,
      logOpportunityEvent,
      track,
      callback,
      context,
      isReject,
      isFromSummary,
      isFromAutoApplyDialog,
      i18n,
      showAlertHandler,
      isDismissAll,
      useCallbackAsSubmit,
      isFromImgExtV2,
      opportunities,
    } = this.props;

    if ((isFromSummary && isFromAutoApplyDialog) || useCallbackAsSubmit) {
      callback();
      return;
    }

    if (isFromImgExtV2) {
      if (!_.isEmpty(opportunities)) {
        callback(opportunities);
      } else {
        callback();
      }
      return;
    }

    this.props.onCancel();

    let options;
    if (reason) {
      const formatedReason = this.getFormatedReason(reason);
      options = _.extend({}, data, this.props.context && {
        context: this.props.context,
      }, this.props.guid && {
        guid: this.props.guid,
      }, formatedReason && {
        reason: formatedReason,
      });
    }

    if (isProvideFeedbackOnly) {
      // eslint-disable-next-line no-unused-expressions
      logOpportunityEvent && logOpportunityEvent({
        type: data.type,
        action: ADINSIGHT_LOG_ACTION_TYPE.FEEDBACK,
        input: reason.ReasonNote,
        context,
      });
      callback();
      showAlertHandler({
        message: i18n.getString('Recommendation_Feedback_Comment_Success'),
        level: 'Info',
        dismissible: true,
      });
    } else if (isDismissAll) {
      options.context = _.extend({}, options.context, { trackId: generateGuid() });
      if (isFromSummary) {
        // eslint-disable-next-line no-unused-expressions
        logOpportunityEvent && logOpportunityEvent({
          type: data.type,
          action: ADINSIGHT_LOG_ACTION_TYPE.CLICK_DISMISSALL,
          context: options.context,
        });
      }

      options.context = _.extend({}, options.context, { ApplyMode: 'All' });
      track(_.extend(
        {},
        options,
        { userAction: APPLY_ACTION_TYPES.DISMISS },
        { withAll: true },
        { isDismissAll },
        { handleRecommendationNotification }
      ));
      this.navigateBasedOnReason(reason);
    } else if (isReject) {
      track(_.extend({}, options, {
        userAction: APPLY_ACTION_TYPES.REJECT,
      }, { handleRecommendationNotification }));
    } else {
      track(_.extend({}, data, {
        userAction: APPLY_ACTION_TYPES.ACCEPT,
      }, this.props.context && {
        context: this.props.context,
      }, { guid: this.props.guid }, { handleRecommendationNotification }, { view: this.props.view })); // eslint-disable-line
    }
  };

  onCancel = () => {
    this.props.onCancel();
  };

  onYes = () => {
    this.setState({ isNavigateModalOpen: false });
    this.props.viewDetails(this.navigateToDetailType)();
  }

  onNo = () => {
    this.setState({
      isNavigateModalOpen: false,
    });
  }

  getFormatedReason = (reason) => {
    const { isDismissAll, permissions } = this.props;
    let formatedReason = null;
    if (reason.ReasonId) {
      formatedReason = {
        ReasonId: (isDismissAll
          && permissions.IsRecommendationInProductFeedbackLoopEnabled) ?
          reasonToMtTranslator(this.props.data.type, reason.ReasonId) : reason.ReasonId,
      };
    }
    if (reason.ReasonNote) {
      formatedReason = formatedReason || {};
      formatedReason.ReasonNote = reason.ReasonNote;
    }
    return formatedReason;
  }

  navigateBasedOnReason = (reason) => {
    if (reason && reason.ReasonId) {
      switch (reason.ReasonId) {
        case NAVIGATE_REASON.NoBudget: // open navigate modal for certain reason

          this.navigateToDetailType = RECOMMENDATION_TYPES.REALLOCATE_BUDGET;
          if (this.props.recommendationTypesAvailable.includes(this.navigateToDetailType)) {
            // open navigate modal
            this.setState({ isNavigateModalOpen: true });
          }
          break;
        default:
          break;
      }
    }
  }
  render() {
    const {
      data: { type },
      i18n,
      recommendationDescription,
      isOpen,
      isProvideFeedbackOnly,
      readOnly,
      isReject,
      isApplyFeedBackFormShow,
      cid,
      aid,
      odata,
      onAutoApplyCancel,
      isDismissAll,
      permissions,
      useNavigateModal,
      newI18n,
      isFromImgExtV2,
      dataService,
    } = this.props;


    // If it doesn't show ApplyFeedBackForm, execute apply directly.
    if (!isApplyFeedBackFormShow && !isReject) {
      this.onSubmit();
      return null;
    }

    const navigateModal = (
      useNavigateModal && <NavigateModal
        isOpen={this.state.isNavigateModalOpen}
        i18n={i18n}
        onYes={this.onYes}
        onNo={this.onNo}
        recommendationType={this.navigateToDetailType}
        // eslint-disable-next-line indent
      />
    );

    return (
      <div>
        {isDismissAll &&
          <ReactModal
            isOpen={isOpen}
            onRequestClose={this.onCancel}
            overlayClassName="dismiss-all-recommendation-feedback-overlay react-modal-overlay"
            className="dismiss-all-recommendation-feedback-modal react-modal"
          >
            <DismissAllFeedbackForm
              recommendationDescription={recommendationDescription}
              i18n={i18n}
              newI18n={newI18n}
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
              type={type}
              permissions={permissions}
            />
          </ReactModal>
        }

        {!isDismissAll &&
          <ReactModal
            isOpen={isOpen}
            onRequestClose={this.onCancel}
            overlayClassName="recommendation-feedback-overlay react-modal-overlay"
            className="recommendation-feedback-modal react-modal"
          >
            {isReject &&
              <FeedbackForm
                recommendationDescription={recommendationDescription}
                isProvideFeedbackOnly={isProvideFeedbackOnly}
                i18n={i18n}
                onSubmit={this.onSubmit}
                onCancel={this.onCancel}
                readOnly={readOnly}
                type={type}
              />
            }
            {!isReject &&
              <ApplyFeedbackForm
                recommendationDescription={recommendationDescription}
                isProvideFeedbackOnly={isProvideFeedbackOnly}
                i18n={i18n}
                onSubmit={this.onSubmit}
                onCancel={this.onCancel}
                readOnly={readOnly}
                cid={cid}
                aid={aid}
                odata={odata}
                onAutoApplyCancel={onAutoApplyCancel}
                type={type}
                newI18n={newI18n}
                permissions={permissions}
                isFromImgExtV2={isFromImgExtV2}
                dataService={dataService}
              />
            }
          </ReactModal>
        }
        {navigateModal}
      </div>
    );
  }
}

export const FeedbackModal = withTrack(/* withAll */ true)(feedbackModal);
